export var CommunicationColors;
(function (CommunicationColors) {
  CommunicationColors.shade30 = '#004578';
  CommunicationColors.shade20 = '#005a9e';
  CommunicationColors.shade10 = '#106ebe';
  CommunicationColors.primary = '#0078d4';
  CommunicationColors.tint10 = '#2b88d8';
  CommunicationColors.tint20 = '#c7e0f4';
  CommunicationColors.tint30 = '#deecf9';
  CommunicationColors.tint40 = '#eff6fc';
})(CommunicationColors || (CommunicationColors = {}));
export var NeutralColors;
(function (NeutralColors) {
  NeutralColors.black = '#000000';
  NeutralColors.gray220 = '#11100f';
  NeutralColors.gray210 = '#161514';
  NeutralColors.gray200 = '#1b1a19';
  NeutralColors.gray190 = '#201f1e';
  NeutralColors.gray180 = '#252423';
  NeutralColors.gray170 = '#292827';
  NeutralColors.gray160 = '#323130';
  NeutralColors.gray150 = '#3b3a39';
  NeutralColors.gray140 = '#484644';
  NeutralColors.gray130 = '#605e5c';
  NeutralColors.gray120 = '#797775';
  NeutralColors.gray110 = '#8a8886';
  NeutralColors.gray100 = '#979593';
  NeutralColors.gray90 = '#a19f9d';
  NeutralColors.gray80 = '#b3b0ad';
  NeutralColors.gray70 = '#bebbb8';
  NeutralColors.gray60 = '#c8c6c4';
  NeutralColors.gray50 = '#d2d0ce';
  NeutralColors.gray40 = '#e1dfdd';
  NeutralColors.gray30 = '#edebe9';
  NeutralColors.gray20 = '#f3f2f1';
  NeutralColors.gray10 = '#faf9f8';
  NeutralColors.white = '#ffffff';
})(NeutralColors || (NeutralColors = {}));
export var SharedColors;
(function (SharedColors) {
  SharedColors.pinkRed10 = '#750b1c';
  SharedColors.red20 = '#a4262c';
  SharedColors.red10 = '#d13438';
  SharedColors.redOrange20 = '#603d30';
  SharedColors.redOrange10 = '#da3b01';
  SharedColors.orange30 = '#8e562e';
  SharedColors.orange20 = '#ca5010';
  SharedColors.orange10 = '#ffaa44';
  SharedColors.yellow10 = '#fce100';
  SharedColors.orangeYellow20 = '#986f0b';
  SharedColors.orangeYellow10 = '#c19c00';
  SharedColors.yellowGreen10 = '#8cbd18';
  SharedColors.green20 = '#0b6a0b';
  SharedColors.green10 = '#498205';
  SharedColors.greenCyan10 = '#00ad56';
  SharedColors.cyan40 = '#005e50';
  SharedColors.cyan30 = '#005b70';
  SharedColors.cyan20 = '#038387';
  SharedColors.cyan10 = '#00b7c3';
  SharedColors.cyanBlue20 = '#004e8c';
  SharedColors.cyanBlue10 = '#0078d4';
  SharedColors.blue10 = '#4f6bed';
  SharedColors.blueMagenta40 = '#373277';
  SharedColors.blueMagenta30 = '#5c2e91';
  SharedColors.blueMagenta20 = '#8764b8';
  SharedColors.blueMagenta10 = '#8378de';
  SharedColors.magenta20 = '#881798';
  SharedColors.magenta10 = '#c239b3';
  SharedColors.magentaPink20 = '#9b0062';
  SharedColors.magentaPink10 = '#e3008c';
  SharedColors.gray40 = '#393939';
  SharedColors.gray30 = '#7a7574';
  SharedColors.gray20 = '#69797e';
  SharedColors.gray10 = '#a0aeb2';
})(SharedColors || (SharedColors = {}));